module.exports = __webpack_public_path__ + "static/media/picto-magnify-plus.4ee7ffb3.svg";